import { OutlookMethodDispId } from './apis/OutlookMethodDispId';
import ExtensionType from 'owa-service/lib/contract/ExtensionType';
import { ExtensionEntryPointEnum } from 'owa-addins-store';
import ApiErrorCode from './apis/ApiErrorCode';
export default {
    ExecuteApiMethodNoItemFailure: {
        datapoint: {
            name: 'ExtExecuteApiMethodNoItemFailure',
            customData: (dispId: OutlookMethodDispId) => [dispId],
        },
    },
    ExecuteApiMethod: {
        datapoint: {
            name: 'ExecuteApiMethod',
            customData: (
                dispId: OutlookMethodDispId,
                Id: string,
                DisplayName: string,
                module: string, //'Mail' | 'Calendar'
                scenario: string, //'Read' | 'Compose',
                extPoint: ExtensionEntryPointEnum, //'Contextual' | 'TaskPane' | 'UILess' | 'Unknown' |'Dialog'
                lang: string,
                type: ExtensionType,
                errorCode: ApiErrorCode,
                error?: string
            ) => ({
                dispId,
                Id,
                DisplayName,
                owa_1: module,
                owa_2: scenario,
                owa_3: extPoint,
                owa_4: type,
                type,
                errorCode,
                error,
            }),
        },
    },
};
